import { render, staticRenderFns } from "./stepMainForm.vue?vue&type=template&id=1228d332&"
import script from "./stepMainForm.vue?vue&type=script&lang=js&"
export * from "./stepMainForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports